import { axiosRequestGET } from './serviceConfig';

export const fetchMenuItems = () => {
  const url = `/api/menu`;
  return axiosRequestGET(url);
};

export const getTranslationsService = () => axiosRequestGET('/api/translations');
